import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";

const CustomOutsidePOPUP = ({ loanNames = [], onAdd }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ amount: "", name: "" });

  const reset = () => setForm({ amount: "", name: "" });

  const submit = async () => {
    if (!form.amount) return;
    const token = localStorage.getItem("authToken");
    try {
      await axios.post(`${API_BASE_URL}/api/loansave`, {
        token,
        amount: form.amount,
        type: "Payment Outside",
        bank_name: "", // not required here
        name: form.name,
      }, { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } });
      onAdd && onAdd({ amount: form.amount, name: form.name });
      reset();
      setOpen(false);
    } catch (e) {
      console.error('Payment Outside save error:', e?.response?.data || e?.message);
      // fallback local add
      onAdd && onAdd({ amount: form.amount, name: form.name });
      reset();
      setOpen(false);
    }
  };

  return (
    <>
      <button type="button" className="btn btn-warning" onClick={() => setOpen(true)}>
        Add Payment Outside
      </button>
      {open && (
        <div className="modal d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Payment Outside</h5>
                <button type="button" className="close" onClick={() => setOpen(false)}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label>Amount</label>
                  <input type="number" className="form-control" value={form.amount} onChange={(e)=>setForm({...form, amount:e.target.value})} />
                </div>
                <div className="form-group">
                  <label>Name</label>
                  <input list="Loancustomerssuggestions-suggestions" type="text" className="form-control" value={form.name} onChange={(e)=>setForm({...form, name:e.target.value})} />
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={()=>setOpen(false)}>Close</button>
                <button type="button" className="btn btn-primary" onClick={submit}>Add</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomOutsidePOPUP;
